import React, { useEffect, useState } from "react";
import uiManager from '../../../config/ui.js'
import PAGES from '../../data/PagesConstants.js';
import Page from "../Page.js";
import PageContentWrapper from "../../components/PageContentWrapper.js";
import VehiclesForm from "./VehiclesForm.js";
import FormPartial from "./FormPartial.js";
import InspectionItem from "../../models/InspectionItem.js";
import VehicleInspectionItem from "../../models/VehicleInspectionItem.js";
import ItemsList from "./ItemsList.js";

const Index = () => {
  const [vehicleInspectionItems, setVehicleInspectionItems] = useState(null);
  const [allInspectionItems, setAllInspectionItems] = useState([]);
  const inspectionItemObj = new InspectionItem();
  const [inspectionItem, setInspectionItem] = useState(inspectionItemObj.toStateJson());

  const addItemToVehicleInspectionItem = (obj = {}) => {
    let selectedItems = vehicleInspectionItems.inspection_items;
    selectedItems.push(new InspectionItem(obj))
    setVehicleInspectionItems((prevState) => {
      return { ...prevState, inspection_items: selectedItems}
    })
  }

  const checkDisability = (name) => {
    if (vehicleInspectionItems?.inspection_items?.length >  0) {
      const set = new Set( vehicleInspectionItems.inspection_items.map(item => item.name) )
      return set.has(name);
    }
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.InspectionsItemsPage.name)}
    breadcrumbs={[{label: 'Home', url: '/dashboard'}, {label: 'Vehicle Inspection Items'}]}
    className="vehicle-inspections-listing-page"
  >
    <PageContentWrapper contentHeading={"Inspection Items[Page under Development]"}>
      <div className="row mt-2 mx-1">
        <VehiclesForm setVehicleInspectionItems={setVehicleInspectionItems} setAllInspectionItems={setAllInspectionItems}/>
      </div>
      <div className="row mt-4 mx-2 pb-4">
        <div className="col-9 border p-3">
         <h6 title="Items are already present in vehicle.">Items in vehicle</h6>
          <div className="row mt-2">
            { vehicleInspectionItems != null && vehicleInspectionItems.inspection_items != null && vehicleInspectionItems.inspection_items.length > 0 &&
              <>
                {vehicleInspectionItems.inspection_items.map((inspectionItem)=>{
                  return <FormPartial key={JSON.stringify(inspectionItem)} inspectionItem={inspectionItem} setVehicleInspectionItems={setVehicleInspectionItems}/>
                })}
              <div><button type="button" className="btn btn-voltup-theme ms-3">Submit</button></div>
              </>
            }
          </div>
        </div>
        <div className="col-3 border p-3">
         <h6 className="text-center">All Items</h6>
          {allInspectionItems.map(item => {return <ItemsList name={item.name} disable={checkDisability(item.name)} addItemToVehicleInspectionItem={addItemToVehicleInspectionItem}/>})}
        </div>
      </div>
    </PageContentWrapper>
  </Page>
};

export default Index;
